import React from 'react';
import { Button } from "flowbite-react";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast, { Toaster } from "react-hot-toast";
import classNames from "classnames";
import { FiShare } from "react-icons/fi";
import { MdOutlineClose } from "react-icons/md";
import { differenceInDays, endOfDay, startOfDay, toDate, parseISO } from "date-fns";
import styles from "../styles/Share.module.css";
import { useSearchContext } from "../utils/Context";
import { decompress, gaEvent } from "../utils/Utils";
import { KeywordsRegex } from "../utils/Constants";
import { Config } from "../../app.config";

// https://dev.to/franciscomendes10866/how-to-create-a-notificationtoast-using-react-and-tailwind-545o
var Share = function Share() {
  var _useSearchContext = useSearchContext(),
    shareUrl = _useSearchContext.shareUrl,
    totalCount = _useSearchContext.totalCount;
  var onSuccess = function onSuccess() {
    toast.custom(function (t) {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames([styles.notificationWrapper, t.visible ? "top-0" : "-top-96"])
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.iconWrapper
      }, /*#__PURE__*/React.createElement(FiShare, null)), /*#__PURE__*/React.createElement("div", {
        className: styles.contentWrapper
      }, /*#__PURE__*/React.createElement("h1", null, "Share Link Copied"), /*#__PURE__*/React.createElement("p", null, "You may now paste the link where needed.")), /*#__PURE__*/React.createElement("div", {
        className: styles.closeIcon,
        onClick: function onClick() {
          return toast.dismiss(t.id);
        }
      }, /*#__PURE__*/React.createElement(MdOutlineClose, null)));
    }, {
      id: "share-notification",
      position: "top-center"
    });
    var urlHash = shareUrl.split("#")[1];
    var formData = decompress(urlHash);
    gaEvent("share", {
      category: "Share",
      label: "share",
      value: formData.query,
      nonInteraction: true
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: shareUrl,
    onCopy: onSuccess
  }, /*#__PURE__*/React.createElement(Button, {
    color: "blue",
    size: "xs",
    "aria-label": "Share Search Results",
    title: "Share Search Results"
  }, /*#__PURE__*/React.createElement(FiShare, {
    className: "md:mr-2 h-4 w-4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden md:inline"
  }, "Share"))), /*#__PURE__*/React.createElement(Toaster, null));
};
export default Share;